export enum CobStatus {
    RECONFIGURE = 'reconfigure',
    DELETE = 'delete',
    UPDATE = 'update',
    CREATE = 'create'
  }
  
  export const cobStatuses = Object.values(CobStatus);
  